import { setLocale } from '@faks/shared';
import { i18n } from '@lingui/core';

const importByLocale = {
  fr: () => import('./fr.po').then((module) => module.messages),
};

const locale = 'fr';

export const initLingui = async () => {
  const messages = await importByLocale[locale]();
  i18n.loadAndActivate({ locale, messages });
  setLocale(locale);
};

export { i18n };
